exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".readtest__text--blur span[data-v-604fc2c5]:not(:first-child){filter:blur(3px)}.game__name[data-v-604fc2c5]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;align-items:center}.game__name[data-v-604fc2c5],.game__name a[data-v-604fc2c5],.trainer__menu[data-v-604fc2c5]{margin-top:10px}.menu-buttons[data-v-604fc2c5]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;justify-content:center}.menu-buttons a[data-v-604fc2c5]:first-child{margin-right:20px}.finish-btn[data-v-604fc2c5]{margin-top:20px;align-self:center}", ""]);

// exports
